import React from 'react';
import { useHistory } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import { Breadcrumb } from 'components';
import ButtonLikeTabs from 'components/common/ButtonLikeTabs/ButtonLikeTabs';
import TableChart from 'components/common/TableChart/TableChart';
import ShopDialog from 'components/common/Dialog/Dialog';
import Button from '@material-ui/core/Button';

import './Setting.scss';

const AccountAll = () => {
  const history = useHistory();
  const link = "/setting/createAccount"
  const deleteButton = (<Button className='deleteButton' variant="contained" onClick={() => { handleClickOpen() }}>削除</Button>)
  const editButton = (<Button className='editButton' variant="contained" onClick={() => { history.push(link) }}>編集</Button>)
  const controlDiv = (<div className='controlDiv' >{deleteButton}{editButton} </div>)

  const tableCols = [
    { name: 'a', label: '発行日', align: "left", width: 120 },
    { name: 'b', label: '発行先名', align: "left", width: 120 },
    { name: 'c', label: 'ユーザーID', align: "right", width: 120 },
    { name: 'd', label: 'パスワード', align: "right", width: 120 },
    { name: 'e', label: '操作', align: "right", width: 160 },
  ]
  const _tableData = [
    { a: '2021年2月3日(火)', b: '株式会社カラーズ', c: 'colors', d: 'derg45y', e: controlDiv, },
    { a: '2021年2月3日(火)', b: '株式会社カラーズ', c: 'colors', d: 'derg45y', e: controlDiv, },
    { a: '2021年2月3日(火)', b: '株式会社カラーズ', c: 'colors', d: 'derg45y', e: controlDiv, },
    { a: '2021年2月3日(火)', b: '株式会社カラーズ', c: 'colors', d: 'derg45y', e: controlDiv, },
  ]

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };


  return (
    <div id="AccountAll" className="pb-24 px-8 bg-default">
      <div className="breadcrumb">
        <Breadcrumb routeSegments={[{ name: '設定メニュー', path: '/setting/account' },
        { name: 'アカウント発行', path: '/setting/createAccount' }, { name: '発行先一覧' }]} />
      </div>

      <h2>発行先一覧</h2>
      <Divider style={{ backgroundColor: "#777", marginBottom: 20 }} className="topDivider" />

      <ButtonLikeTabs text1="発行" text2="発行先一覧" disabled={'text2'}
        link="/setting/createAccount" />

      <TableChart
        id="table-daily"
        cols={tableCols}
        data={_tableData}
        idCol="a"//dataの中のuidを指定
        firstRowBlue={false}
      />

      <ShopDialog
        open={open}
        // title="削除してよろしいですか？"
        contents="削除してよろしいですか？"
        handleClickOpen={handleClickOpen}
        handleClose={handleClose} />

    </div>
  );
};

export default AccountAll;
